import { Container, Box, Button } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Body2 } from '../../themes/typography';

export default function Alerts({
    bannerText = 'KYC verification is pending',
    buttonText = 'Verify',
    icon = <AccessTimeIcon color="secondary" sx={{ fontSize: '1rem' }} />,
    onClick = () => console.log('Button clicked')
}) {
    return (
        <Container
            sx={{
                flex: 1,
                backgroundColor: 'rgba(248, 162, 30, 0.08)',
                padding: '0.5rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(248, 162, 30, 0.25)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                '&.MuiContainer-root': {
                    paddingLeft: '0.75rem',
                    paddingRight: '0.75rem'
                }
            }}
        >
            <Box sx={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <Box
                    sx={{
                        backgroundColor: 'var(--warning-light-bg-color)',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '0.35rem'
                    }}
                >
                    {icon}
                </Box>
                <Body2>{bannerText}</Body2>
            </Box>
            <Box>
                <Button
                    variant="text"
                    sx={{
                        padding: '0',
                        fontSize: '1rem'
                    }}
                    disableRipple
                    onClick={onClick}
                >
                    {buttonText}
                </Button>
            </Box>
        </Container>
    );
}
